import React from 'react';
import { CreditCard, Ticket } from 'lucide-react';

interface CalendarPricingProps {
  paymentType: 'free' | 'subscription' | 'one_time';
  subscriptionPriceCents?: number | null;
  eventPriceCents?: number | null;
  className?: string;
}

export default function CalendarPricing({
  paymentType,
  subscriptionPriceCents,
  eventPriceCents,
  className = ''
}: CalendarPricingProps) {
  if (paymentType === 'free') {
    return null;
  }

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {paymentType === 'subscription' && subscriptionPriceCents ? (
        <div className="inline-flex items-center space-x-2 px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm font-medium">
          <CreditCard className="h-4 w-4" />
          <span>${(subscriptionPriceCents / 100).toFixed(2)}/month</span>
        </div>
      ) : paymentType === 'one_time' && eventPriceCents ? (
        <div className="inline-flex items-center space-x-2 px-3 py-1 bg-emerald-100 text-emerald-800 rounded-full text-sm font-medium">
          <Ticket className="h-4 w-4" />
          <span>${(eventPriceCents / 100).toFixed(2)}/event</span>
        </div>
      ) : null}
    </div>
  );
}